// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-descuento[data-v-3aecd2ea] {\n  background-color: #f5f5f5;\n}\n.discount-component[data-v-3aecd2ea] {\n  margin-bottom: 80px;\n}\n@media (min-width: 1050px) {\n.discount-component[data-v-3aecd2ea] {\n    margin-bottom: 50px;\n}\n}", ""]);
// Exports
module.exports = exports;
